import { render } from "./RequestsList.vue?vue&type=template&id=2dda152f&scoped=true"
import script from "./RequestsList.vue?vue&type=script&lang=js"
export * from "./RequestsList.vue?vue&type=script&lang=js"

import "./RequestsList.vue?vue&type=style&index=0&id=2dda152f&scoped=true&lang=css"

import exportComponent from "D:\\Shehab\\Coding\\vue\\Maxmillian\\Vue-The-Complete-Guide\\lec 18\\deploy01-starting-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dda152f"]])

export default __exports__